import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Briefcase, Mail } from 'lucide-react';
import { FinanceLayout, Pill, Empty, money } from './FinanceLayout';
import { useAuth } from '../../App';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FinanceAnalyticsClientsPage() {
  const { token } = useAuth();
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/admin/analytics-subscriptions`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setSubs(r.data || []))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <FinanceLayout title="Analytics clients" subtitle="B2B Visitor Intelligence subscribers">
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 flex items-start gap-3">
        <Briefcase className="w-5 h-5 text-blue-700 mt-0.5 flex-shrink-0" />
        <div className="text-sm">
          <p className="font-bold text-blue-900">B2B Visitor Intelligence subscribers</p>
          <p className="text-blue-800 mt-1">Museums, cities and tourism boards paying for recurring visitor-behaviour reports. Manage offers and create new subscriptions under <strong>Admin → B2B Subscriptions</strong>.</p>
        </div>
      </div>
      {loading ? (
        <div className="py-20 flex justify-center"><div className="animate-spin rounded-full h-10 w-10 border-4 border-teal-500 border-t-transparent" /></div>
      ) : subs.length === 0 ? (
        <Empty text="No analytics clients yet. Create your first offer in B2B Subscriptions." />
      ) : (
        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50">
              <tr className="text-xs uppercase tracking-wider text-slate-600">
                <th className="px-4 py-3 text-left font-bold">Organization</th>
                <th className="px-4 py-3 text-left font-bold">Contact</th>
                <th className="px-4 py-3 text-left font-bold">Tour</th>
                <th className="px-4 py-3 text-left font-bold">Plan</th>
                <th className="px-4 py-3 text-right font-bold">Price</th>
                <th className="px-4 py-3 text-left font-bold">Next bill</th>
                <th className="px-4 py-3 text-left font-bold">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {subs.map(s => (
                <tr key={s.subscription_id} className="hover:bg-slate-50">
                  <td className="px-4 py-3 font-bold text-slate-900">{s.org_name}</td>
                  <td className="px-4 py-3">{s.contact_name}<div className="text-xs text-slate-500"><Mail className="w-3 h-3 inline mr-1" />{s.contact_email}</div></td>
                  <td className="px-4 py-3 text-slate-700">{s.tour_title}</td>
                  <td className="px-4 py-3"><span className="capitalize">{s.tier}</span> · {s.report_cadence}</td>
                  <td className="px-4 py-3 text-right font-bold">{money(s.price_usd)}<span className="text-xs font-normal text-slate-500"> /{s.billing_interval === 'yearly' ? 'yr' : 'mo'}</span></td>
                  <td className="px-4 py-3">{(s.current_period_end || '').slice(0, 10) || '—'}</td>
                  <td className="px-4 py-3">
                    <Pill tone={s.status === 'active' && !s.cancel_at_period_end ? 'emerald' : s.cancel_at_period_end ? 'amber' : 'slate'}>
                      {s.cancel_at_period_end ? 'Canceling' : s.status}
                    </Pill>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </FinanceLayout>
  );
}
